import React, { createContext, useContext, useState, useCallback } from "react"

const ViewModeContext = createContext({ view: "grid", toggle: () => {} })

export function ViewModeProvider({ children }) {
    const [view, setView] = useState("grid")
    const toggle = useCallback(() => setView(v => (v === "grid" ? "circle" : "grid")), [])
    return <ViewModeContext.Provider value={{ view, toggle }}>{children}</ViewModeContext.Provider>
}

export function useViewMode() {
    return useContext(ViewModeContext)
}
